module.exports = __webpack_public_path__ + "static/media/MSungHK-Light.0493d892.svg";